// Blog.jsx
import CincinnatiBreweries from "../posts/CincinnatiBreweries";
import DerbyWeekCelebrate from "../posts/DerbyWeekCelebrate";
import OutdoorOasis from "../posts/OutdoorOasis";
import FamilyStaycation from "../posts/FamilyStaycation";
import AccentWall from "../posts/AccentWall";
import KeenelandFeels from "../posts/KeenelandFeels";

export const BLOG_POSTS = [
  {
    id: 1,
    slug: "cincinnati-breweries-to-visit-this-spring",
    title: "Cincinnati Breweries to Visit This Spring",
    author: "Kentucky Home Living",
    category: "Lifestyle",
    heroImage: "/imgs/blog/breweries/Blog.png",
    excerpt: "A local list of spring-worthy breweries around Cincinnati and NKY.",
    component: CincinnatiBreweries,
  },
  {
    id: 2,
    slug: "kentucky-derby-week-heres-how-to-celebrate",
    title: "Kentucky Derby Week: Here’s How to Celebrate",
    author: "Kentucky Home Living",
    category: "Events",
    heroImage: "/imgs/blog/derby/hero.jpeg",
    excerpt: "Simple ways to bring Derby energy to your week — parties, food, and traditions.",
    component: DerbyWeekCelebrate,
  },
  {
    id: 3,
    slug: "how-to-create-an-outdoor-oasis",
    title: "How to Create an Outdoor Oasis",
    author: "Kentucky Home Living",
    category: "Home",
    heroImage: "/imgs/blog/oasis/hero.jpeg",
    excerpt: "Turn a patio, deck, or yard into a relaxing outdoor room with a few smart upgrades.",
    component: OutdoorOasis,
  },
  {
    id: 4,
    slug: "family-staycation-ideas-near-cincinnati-and-northern-kentucky",
    title: "Family Staycation Ideas Near Cincinnati and Northern Kentucky",
    author: "Kentucky Home Living",
    category: "Lifestyle",
    heroImage: "/imgs/blog/staycation/hero.jpg",
    excerpt: "Easy day trips and mini adventures that feel like vacation without the travel headache.",
    component: FamilyStaycation,
  },
  {
    id: 5,
    slug: "how-to-create-an-eye-catching-accent-wall",
    title: "How to Create an Eye-Catching Accent Wall",
    author: "Kentucky Home Living",
    category: "Home",
    heroImage: "/imgs/blog/accent-wall/hero.jpg",
    excerpt: "Paint, wallpaper, trim, texture — pick the right approach and nail the details.",
    component: AccentWall,
  },
  {
    id: 6,
    slug: "keeneland-gives-you-all-the-kentucky-feels",
    title: "Keeneland Gives You All the Kentucky Feels",
    author: "Kentucky Home Living",
    category: "Travel",
    heroImage: "/imgs/blog/keeneland/hero.jpeg",
    excerpt: "A guide to making a day at Keeneland feel like a full Kentucky experience.",
    component: KeenelandFeels,
  },
];

export function getPostBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}
